
let varianceAnalysisConstants = {
  ThresholdPercent:{
    DEFAULT_THRESHOLD_PERCENT: 99999
  },
  // Default values for threshold initialization
  DEFAULTS: {
    THRESHOLD_VALUE: 0.001,
    CONTROL_PERCENT_VALUE: 999999,
  },
  idToClCodeMap: {
    "DESIGNATED": "DESTOT",
    "LOCAL": "LOCTOT",
  },
  CLIENT_SALES_BREAKDOWN: {
    RU_TYPE: {
      SOXID: 'soxid',
      RU: 'ru',
      GROUP_M: 'groupm',
    },
    CL_CODES: {
      LOCTOT: 'LOCTOT',
      DESTOT: 'DESTOT',
      CLITOT: 'CLITOT',
      TOTCLI: 'TOTCLI',
    },
    CL_TYPES: {
      LOCAL: 'LOCAL',
      DESIGNATED: 'DESIGNATED',
      OTHER: 'OTHER',
      OTHERS: 'OTHERS',
      TOTAL: 'TOTAL',
      SUBTOTAL: 'SUBTOTAL',
    },
    VIEW_MODES: {
      GROUPED: 'grouped',
      UNGROUPED: 'ungrouped',
    },
    HEADER_DATA_TYPES : {
      FINANCIAL_NUMBER: "financialNumber"
    }
  },
  REPORTING_UNIT: {
    PAGE_SIZE: 25,
    VIRTUAL_SCROLL_THRESHOLD: 3,
    DEFAULT_TOTAL_COUNT: 100,
    LAZY_LOAD_DEBOUNCE_MS: 50,
    LAZY_LOAD_BOTTOM_THRESHOLD_PX: 300,
  },
  REPORTING_TYPES: {
    PL: 'pl',
    BS: 'bs',
    PL_LABEL: 'Profit & Loss',
    BS_LABEL: 'Balance Sheet',
    OTHER_LABEL: 'Other',
  },
  STAGES: {
    STAGE_LOCAL: "stage_local",
    STAGE_REGIONAL: "stage_regional",
    COMMENTARY_AWAITING: 0,
    COMMENTARY_NIL_VALUE: 3,
    IMMATERIAL_VARIANCE: 4,
    COMMENTARY_NOT_IN_SCOPE: 5
  },
  JV_COMMENTARY: {
    ACTUAL: "jv_commentary1",
    FORECAST: "jv_commentary2"
  },
  WORKFLOWS_STATUS: {
    IS_LOCAL_ENABLED: "islocalenabled",
    IS_REGIONAL_ENABLED: "isregionalenabled",
    IS_WORKFLOW_ENABLED: "isworkflowsenabled"
  },
  ACTIONS: {
    ADD_LOCAL_COMMENTARY: "addlocal",
    ADD_REGIONAL_COMMENTARY: "addregional",
    VIEW: "view",
    APPROVE_LOCAL: "approvelocal",
    APPROVE_REGIONAL: "approveregional",
    REQUEST_LOCAL: "requestlocal",
    REQUEST_REGIONAL: "requestregional"
  },
  TOGGLE_STATES: {
    RU_VIEW:0,
    CARD_VIEW:1,
    TABLE_VIEW:2,
    DASHBOARD_VIEW:3
  },
  API_ENDPOINTS:{
    ENABLE_DISABLE_WORKFLOW: "/v3/varianceanalysis/reportingunit/enabledisableworkflow/",
    ENABLE_DISABLE_BULK_APPROVE: "/v3/varianceanalysis/reportingunit/enabledisablebulkapprove",
    ENABLE_DISABLE_BULK: "/v3/varianceanalysis/reportingunit/bulkenabledisableworkflow",
    ENABLE_DISABLE_REGIONAL_COMMENTARY_AUTO_SUBMISSION: "/v3/varianceanalysis/reportingunit/enabledisableRegionalCommentaryAutoSubmission",
    UPDATE_SOD_STATUS: "/v3/varianceanalysis/reportingunit/updateSODStatus",
    GET_RU_FILTERS: "/v3/varianceanalysis/reportingunit/getRUFilters",
    GET_MY_RUS: "/v3/varianceanalysis/reportingunit/getmyrus",
    CALCULATE_MATERIALITY: "/v3/varianceanalysis/reportingunit/calculateMateriality",
    GET_MY_RU_DETAIL: "/v3/varianceanalysis/reportingunit/getmyrudetail/",
    GET_CYCLE_SUMMARIES: "/v3/varianceanalysis/analysis/getcyclesummaries",
    GET_ALL_REPORTING_UNITS: "/v3/varianceanalysis/reportingunit/getalllist",
    GET_GL_LIST: "/v2/varianceanalysis/gllist/get",
    GET_PENDING_APPROVAL_REQUESTS: "/v2/varianceanalysis/materiality/getpendingrequest",
    GET_MY_MATERIALITY: "/v2/varianceanalysis/materiality/getmy/",
    ADD_BULK_WORKFLOW: "/v3/varianceanalysis/reportingunit/addbulkfileuploadworkflow",
    GET_RU_INSIGHTS: "/v3/varianceanalysis/reportingunit/ru-insights",
  },
  MESSAGES:{
    SETTINGS_UPDATED_SUCCESSFULLY: "Settings updated successfully",
    FAILED_TO_UPDATE_SETTINGS: "Failed to update settings. Please try again.",
    FAILED_TO_UPDATE_WORKFLOW: "Failed to update workflow settings. Please try again.",
    SELECT_VALID_GLS:"Please select GL’s that are in Local Commentary Awaiting Approval Status",
    FAILED_TO_UPDATE_BULK_APPROVE_SETTINGS:"Failed to update bulk approve settings",
    FAILED_TO_UPDATE_AUTO_SUBMISSION_SETTINGS:"Failed to update auto submission settings",
    FAILED_TO_UPDATE_SOD_STATUS:"Failed to update SOD status",
    MULTIPLE_ROLES:"Multiple Roles",    
    FAILED_TO_FETCH_REPORTING_UNITS: "Error reading reporting units data",
    FAILED_TO_FETCH_GL_LIST: "Error reading GL list data",
    FAILED_TO_FETCH_PENDING_REQUESTS: "Error reading pending request data",
    FAILED_TO_FETCH_MATERIALITY: "Error reading materiality data", 
    RU_INSIGHTS_FETCHED_SUCCESSFULLY: "Reporting unit insights retrieved successfully",
    FAILED_TO_FETCH_RU_INSIGHTS: "Failed to retrieve reporting unit insights. Please try again.",  
  },
  STATUS: {
    SUCCESS: 'success',
    FAILED: 'failed',
    REJECTED: 'rejected',
  },
  AUTO_SUBMISSION_COLUMNS: [
    "Local Approve & Submit (Yes/No)",
    "Local Approve & Submit Reason"
  ],
   BULK_SUBMIT_COLUMNS_ACTUAL: [
      "GL Code",
      "Description",
      "Actual Amount",
      "Proforma Amount",
      "Variance Amt(Act vs Pro)",
      "Variance %(Act vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs Pro Commentary",
      "Regional Act vs Pro Commentary",
      "Forecast Amount",
      "Variance Amt(Act vs For)",
      "Variance %(Act vs For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local Act vs For Commentary",
      "Regional Act vs For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
    BULK_SUBMIT_COLUMNS_FORECAST: [
      "GL Code",
      "Description",
      "Forecast Amount",
      "Proforma Amount",
      "Variance Amt(For vs Pro)",
      "Variance %(For vs Pro)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Pro Commentary",
      "Regional For vs Pro Commentary",
      "Previous Forecast Amount",
      "Variance Amt(For vs Prev For)",
      "Variance %(For vs Prev For)",
      "Cross Local Ctrl",
      "Cross Local Mngt",
      "Cross Regional Ctrl",
      "Cross Regional Mngt",
      "Local For vs Prev For Commentary",
      "Regional For vs Prev For Commentary",
      "Status Local",
      "Status Regional",
      "Local Approve/Reject (Yes/No)",
      "Local Approve/Reject Reason",
      "Regional Approve/Reject (Yes/No)",
      "Reject - Local Level (LA/LP)",
      "Regional Approve/Reject Reason",
      "Local Approve & Submit (Yes/No)",
      "Local Approve & Submit Reason",
    ],
  CYCLE_TYPES: {
    ACTUAL: "Actual",
    FORECAST: "Forecast"
  },
  TABS: {
    WORKFLOW: 0,
    OTHER: 1
  },
  TAB_NAMES:{
    WORKFLOW:"WORKFLOW",
    OTHER:"OTHER"
  },
  AI_FILTERS: {
    PRODUCT: 'flux',
    MODULE: 'ai_summarization'
  },
  SOD:{
    STATUS:{
      ENABLED:"Enabled",
      DISABLED:"Disabled"
    },
    MESSAGES:{
      SOD_MIXED_WARNING:"SOD is disabled for a/few ReportingUnit(s). Kindly submit a separate access request for the SOD disabled RU(s).",
      UNKNOWN_ERROR:"Unknown error"
    },
    STYLE:{
      HIGHTLIGHT_SELF:"highlight-chip highlight-chip--self",
      HIGHTLIGHT_MULTI_ROLE:"highlight-chip",
      RED:"#c62828",
      WHITE:'white'
    }
  },
  MATERIALITY: {
    NOTES: {
      COMMON: [
        'All numbers reported in the Commentary Application are in USD thousands (For instance, entering an amount/percentage of "30" corresponds to USD 30,000).',
        'The Local and Regional Control percentages are set to 999999% by default and cannot be edited.',
      ],
      VIEW_MODE: [
        'Materiality can be viewed for the past 24 months and till the current financial year.',
      ],
      EDIT_MODE: [
        'Materiality can be updated only for the current financial year.',
        'To update materiality at GL & Drill Down level for multiple periods, please use the bulk file upload option.',
      ],
    },
    BULK_SUBMIT_RU_FILE_COLUMNS: ["rucode", "runame", 'month', 'year', 'a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro','a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro','a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore',
                                'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore', 'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro', 'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro',
                                'f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 'f_m_l_per_fore','f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'],
    BULK_SUBMIT_GL_FILE_COLUMNS: ["rucode", "runame", "glcode", "glname", 'month','year','a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro','a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro','a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore',
                                'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore', 'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro', 'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro','f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 
                                'f_m_l_per_fore','f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'],
    HEADERS: [
        {
          value: "indexno",
          text: "S.No",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "code",
          text: "RU Code & Name", // Will be localized in component
          sortable: false,
          filterable: true,
          lock: true,
        },
        // {
        //   value: "name",
        //   text: "Name",
        //   sortable: false,
        //   filterable: true,
        //   lock: true,
        // },
        {
          value: "network",
          text: "Network", // Will be localized in component
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "region",
          text: "Region", // Will be localized in component
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "country",
          text: "Country", // Will be localized in component
          sortable: false,
          filterable: true,
          lock: true,
        },
        {
          value: "currency",
          text: "Currency",
          sortable: false,
          filterable: false,
          lock: false,
          visible: false,
        },
        {
          value: "created_at",
          text: "Created At",
          sortable: true,
          filterable: true,
          datatype: "date",
          lock: false,
          visible: false,
        },
        {
          value: "updated_at",
          text: "Updated At",
          sortable: false,
          filterable: false,
          datatype: "date",
          lock: false,
          visible: false,
        },
        {
          value: "action",
          text: "Action", // Will be localized in component
          sortable: false,
          datatype: "action",
          lock: true,
          visible: false,
          width: "170px",

        },
      ],
    GL_HEADERS: [
        {
          value: "code",
          text: "GL Code", // Will be localized in component
          sortable: false,
          filterable: true,
        },
        {
          value: "name",
          text: "Name",
          sortable: true,
          filterable: true,
          lock: true,
        },
        {
          value: "datatypes",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "edit_buttons",
          text: "",
          sortable: false,
          filterable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount",
          text: "LC Amt", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "control_thresholds_percent",
          text: "LC %", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "management_thresholds_amount",
          text: "LM Amt", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "management_thresholds_percent",
          text: "LM %", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "control_thresholds_amount_regional",
          text: "RC Amt", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "control_thresholds_percent_regional",
          text: "RC %", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "management_thresholds_amount_regional",
          text: "RM Amt", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
        {
          value: "management_thresholds_percent_regional",
          text: "RM %", // Will be localized in component
          alignment: "text-right",
          sortable: false,
          lock: true,
        },
      ],
    WISE_TABS: [
        { labelKey: 'commenrary_ru_label', labelFallback: 'RU', value: 'ruWise' },
        { labelKey: 'commentary_gl_shortform_label', labelFallback: 'GL', value: 'glWise' },
        { labelKey: 'commentary_sl_shortform_label', labelFallback: 'Drill-Down', value: 'slWise' },
      ],
    UPLOAD_TABS: [
        { labelKey: 'commentary_ru_label', labelFallback: 'RU', value: 'rufile' },
        { labelKey: 'commentary_gl_shortform_label', labelFallback: 'GL', value: 'glfile' },
        { labelKey: 'commentary_sl_shortform_label', labelFallback: 'Drill-Down', value: 'slfile' },
      ],
    FAQ_CONTENT: [
        {
          'question':'What is materiality? How can I update this?',
          'answer': "Materiality involves establishing specific thresholds (values or percentages) at the local or regional level by Tool Admin Preparers. These thresholds help identify GL's that exceed the control or management threshold set based on the materiality criteria.The numbers in the application will be in USD and hence the thresholds are expected to be in USD.For a detailed explanation and step by step instruction, please refer the section in the user manual on 'Materiality'",
        },
        {
          'question': 'What should I do if I encounter issues with the Materiality feature, such as being unable to set it up or view specific GLs?',
          'answer': [' Refresh the screen and try in 10 minutes','If issues persist, reach out to the Consark Support Team with the issue and screenshot if any']
        }
      ],
    
    THRESHOLD_KEYS: [
            'control_thresholds_amount_proforma', 'control_thresholds_percent_proforma',
            'management_thresholds_amount_proforma', 'management_thresholds_percent_proforma',
            'control_thresholds_amount_regional_proforma', 'control_thresholds_percent_regional_proforma',
            'management_thresholds_amount_regional_proforma', 'management_thresholds_percent_regional_proforma',
            'control_thresholds_amount_forecast', 'control_thresholds_percent_forecast',
            'management_thresholds_amount_forecast', 'management_thresholds_percent_forecast',
            'control_thresholds_amount_regional_forecast', 'control_thresholds_percent_regional_forecast',
            'management_thresholds_amount_regional_forecast', 'management_thresholds_percent_regional_forecast',
          ],
    // Proforma threshold keys (full property names)
    PROFORMA_THRESHOLD_KEYS: [
      'control_thresholds_amount_proforma', 'control_thresholds_percent_proforma',
      'management_thresholds_amount_proforma', 'management_thresholds_percent_proforma',
      'control_thresholds_amount_regional_proforma', 'control_thresholds_percent_regional_proforma',
      'management_thresholds_amount_regional_proforma', 'management_thresholds_percent_regional_proforma',
    ],
    // Forecast threshold keys (full property names)
    FORECAST_THRESHOLD_KEYS: [
      'control_thresholds_amount_forecast', 'control_thresholds_percent_forecast',
      'management_thresholds_amount_forecast', 'management_thresholds_percent_forecast',
      'control_thresholds_amount_regional_forecast', 'control_thresholds_percent_regional_forecast',
      'management_thresholds_amount_regional_forecast', 'management_thresholds_percent_regional_forecast',
    ],
    ACTUAL_KEYS: [
        'a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro',
        'a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro',
        'a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore',
        'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore',
      ],
    DATA_VALUES: [
        'control_thresholds_amount_proforma','control_thresholds_percent_proforma','management_thresholds_amount_proforma',
        'management_thresholds_percent_proforma','control_thresholds_amount_regional_proforma','control_thresholds_percent_regional_proforma',
        'management_thresholds_amount_regional_proforma','management_thresholds_percent_regional_proforma','control_thresholds_amount_forecast',
        'control_thresholds_percent_forecast','management_thresholds_amount_forecast','management_thresholds_percent_forecast',
        'control_thresholds_amount_regional_forecast','control_thresholds_percent_regional_forecast','management_thresholds_amount_regional_forecast',
        'management_thresholds_percent_regional_forecast'
      ],
    FORECAST_KEYS: [
        'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro',
        'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro',
        'f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 'f_m_l_per_fore',
        'f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'
      ],
    ACTUAL_LOCAL_PROFORMA: [
      'a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro'
    ],
    ACTUAL_REGIONAL_PROFORMA: [
      'a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro'
    ],
    ACTUAL_LOCAL_FORECAST: [
      'a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore'
    ],
    ACTUAL_REGIONAL_FORECAST: [
      'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore'
    ],
    FORECAST_LOCAL_PROFORMA: [
      'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro'
    ],
    FORECAST_REGIONAL_PROFORMA: [
      'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro'
    ],
    FORECAST_LOCAL_FORECAST: [
      'f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 'f_m_l_per_fore'
    ],
    FORECAST_REGIONAL_FORECAST: [
      'f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'
    ],
    IGNORED_FIELDS: ['a_c_l_per_pro', 'a_c_r_per_pro', 'f_c_l_per_pro', 'f_c_r_per_pro'],
    
    // Default threshold values
    DEFAULT_THRESHOLD_VALUE: 0.001,
    DEFAULT_CONTROL_PERCENT: 999999,
    
    /**
     * Factory function to create default GL/RU threshold values
     * Control percentages (proforma local & regional) are set to 999999 (non-editable)
     * All other values default to 0.001
     * @returns {Object} Default threshold object for GL/RU level
     */
    getDefaultGLThresholds() {
      return {
        control_thresholds_amount_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_proforma: this.DEFAULT_CONTROL_PERCENT,
        management_thresholds_amount_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_regional_proforma: this.DEFAULT_CONTROL_PERCENT,
        management_thresholds_amount_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
      };
    },
    
    /**
     * Factory function to create default SL (drilldown) threshold values
     * All values default to 0.001 (including control percentages)
     * @returns {Object} Default threshold object for SL level
     */
    getDefaultSLThresholds() {
      return {
        control_thresholds_amount_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_regional_proforma: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_amount_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        control_thresholds_percent_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_amount_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
        management_thresholds_percent_regional_forecast: this.DEFAULT_THRESHOLD_VALUE,
      };
    },
    
    /**
     * Alias for getDefaultGLThresholds - RU level uses same defaults as GL
     * @returns {Object} Default threshold object for RU level
     */
    getDefaultRUThresholds() {
      return this.getDefaultGLThresholds();
    },

    BULK_SUBMIT_RU_FILE_COLUMNS_ACTUAL: ["rucode", "runame", "month", "year", 'a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro','a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro','a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore',
                                  'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore'],
    BULK_SUBMIT_GL_FILE_COLUMNS_ACTUAL: ["rucode", "runame", "glcode", "glname", "month", "year", 'a_c_l_amt_pro', 'a_c_l_per_pro', 'a_m_l_amt_pro', 'a_m_l_per_pro','a_c_r_amt_pro', 'a_c_r_per_pro', 'a_m_r_amt_pro', 'a_m_r_per_pro','a_c_l_amt_fore', 'a_c_l_per_fore', 'a_m_l_amt_fore', 'a_m_l_per_fore',
                                  'a_c_r_amt_fore', 'a_c_r_per_fore', 'a_m_r_amt_fore', 'a_m_r_per_fore'],
    BULK_SUBMIT_RU_FILE_COLUMNS_FORECAST: ["rucode", "runame", "month", "year", 'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro', 'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro',
                                  'f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 'f_m_l_per_fore','f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'],
    BULK_SUBMIT_GL_FILE_COLUMNS_FORECAST: ["rucode", "runame", "glcode", "glname", "month", "year", 'f_c_l_amt_pro', 'f_c_l_per_pro', 'f_m_l_amt_pro', 'f_m_l_per_pro', 'f_c_r_amt_pro', 'f_c_r_per_pro', 'f_m_r_amt_pro', 'f_m_r_per_pro','f_c_l_amt_fore', 'f_c_l_per_fore', 'f_m_l_amt_fore', 
                                  'f_m_l_per_fore','f_c_r_amt_fore', 'f_c_r_per_fore', 'f_m_r_amt_fore', 'f_m_r_per_fore'],
  }
};

module.exports = varianceAnalysisConstants;